module.exports = __webpack_public_path__ + "media/icons/ilosc-drzwi@3x-10bf2cf7.svg";